var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"logo-msg"},[_c('v-uni-view',{staticClass:"logo"}),_c('v-uni-view',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }